module.exports = __webpack_public_path__ + "static/media/gallery_walkabout.dbe5a0f0.png";